import { LucideIcon } from "lucide-react";

interface ActionButtonProps {
  icon: LucideIcon;
  label: string;
  onClick?: () => void;
}

const ActionButton = ({ icon: Icon, label, onClick }: ActionButtonProps) => {
  return (
    <button
      onClick={onClick}
      className="flex flex-col items-center justify-center gap-2 bg-[#704AAF] hover:bg-[#704AAF]/90 rounded-xl px-4 py-3 transition-all duration-200 shadow-sm min-w-[90px] text-white flex-1 max-w-[150px]"
    >
      <Icon className="w-7 h-7" />
      <span className="text-md font-medium text-center leading-tight">{label}</span>
    </button>
  );
};

export default ActionButton;